const collectRateBaseUrl = `${window.location.protocol}//${window.location.host}/collect-rates/`;
const collectFeeBaseUrl = `${window.location.protocol}//${window.location.host}/collect-fees/`;
const collectCryptoBaseUrl = `${window.location.protocol}//${window.location.host}/collect-crypto/`;

export { collectRateBaseUrl, collectFeeBaseUrl, collectCryptoBaseUrl };
